var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { sprintf } from 'sprintf-js';
import { useEntity } from '../hooks/use-entity';
import { classNames } from '@shapeable/utils';
import { useLang } from '../hooks/use-lang';
import { useImage } from '../hooks/use-image';
var cls = classNames('organisation-logo-external-link');
export var OrganisationLogoExternalLinkDefaultProps = {};
// -------- Styles -------->
var LinkStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: block;\n    img {\n      object-fit: contain;\n      max-height: 100%;\n      max-width: 100%;\n    }\n  "], ["\n    display: block;\n    img {\n      object-fit: contain;\n      max-height: 100%;\n      max-width: 100%;\n    }\n  "])))
});
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: block;\n    img {\n      object-fit: contain;\n      max-height: 100%;\n      max-width: 100%;\n    }\n  "], ["\n    display: block;\n    img {\n      object-fit: contain;\n      max-height: 100%;\n      max-width: 100%;\n    }\n  "])))
});
// -------- Components -------->
var My = {
  Link: styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Container: styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var OrganisationLogoExternalLink = function (props) {
  var className = props.className,
    isInverted = props.isInverted,
    children = props.children;
  var entity = useEntity(props.entity);
  var t = useLang();
  var url = entity.url,
    name = entity.name;
  var logo = isInverted ? entity.logoInverted || entity.logo : entity.logo;
  var Image = useImage();
  var image = React.createElement(Image, {
    alt: sprintf(t("%s Logo"), name),
    title: name,
    image: logo
  });
  return url ? React.createElement(My.Link, {
    target: "_blank",
    href: url,
    className: className
  }, image) : React.createElement(My.Container, {
    className: className
  }, image);
};
OrganisationLogoExternalLink.defaultProps = OrganisationLogoExternalLinkDefaultProps;
OrganisationLogoExternalLink.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;